export default "__VITE_ASSET__CsEtpzSy__"